export const MESSAGE_ADD = 'MESSAGE_ADD';
export const MESSAGE_REMOVE = 'MESSAGE_REMOVE';
export const MESSAGE_REMOVE_ALL = 'MESSAGE_REMOVE_ALL';
export const MESSAGE_RESET = 'MESSAGE_RESET';
export const MESSAGE_REMOVE_ALL_EXCEPT = 'MESSAGE_REMOVE_ALL_EXCEPT';
